// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___KRPQ6"};
    if(module.hot) {
      // 1697460460913
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  